import React, { useEffect, useState } from "react";
import { useAllCollectedPIC } from "../../../../common/hooks/dataMapHooks";
import { useSurvey } from "../../../../common/hooks/api/useSurvey";
import { Loading } from "../../../components";
import { GetCompliantPageWrapper } from "../../../components/layout/GetCompliantPageWrapper";
import { PageHeader } from "../../../components/layout/header/Header";
import { CorePrivacyConceptsSurvey } from "../../../components/organisms/survey/CorePrivacyConcepts";
import { SurveyGateButton } from "../../../components/organisms/survey/SurveyGateButton";
import { useDataSubjectTypes, usePrimaryOrganizationId } from "../../../hooks";
import { useDataMap } from "../../../../common/hooks/api/useDataMap";
import { useProcessingActivites } from "../../../hooks/useProcessingActivities";

export const CORE_PRIVACY_CONCEPTS_SURVEY = "core-privacy-concepts-survey";
const Header: React.FC = () => {
  return (
    <PageHeader
      titleContent="Minimization"
      descriptionContent={
        <>
          Privacy laws require your business to comply with a few core principles. The prompts on
          this screen will help you understand <strong>the two core privacy concepts</strong> and
          see if your business is complying with them. If not, we’ll work with you to update and
          implement best practices. We will cover:
        </>
      }
    />
  );
};

export const CorePrivacyConceptsPage: React.FC = () => {
  // Variables
  const organizationId = usePrimaryOrganizationId();

  // State
  const [readyToRender, setReadyToRender] = useState(false);

  const {
    answers,
    setAnswer,
    request: surveyRequest,
  } = useSurvey(organizationId, CORE_PRIVACY_CONCEPTS_SURVEY);

  const { data: dataMap, request: dataMapRequest } = useDataMap(organizationId);
  const collectedPic = useAllCollectedPIC(dataMap);

  const [activities, activityRequest] = useProcessingActivites(organizationId);

  // Requests
  const [fetchedConsumerGroups, consumerGroupsRequest] = useDataSubjectTypes(organizationId);

  // Effects
  useEffect(() => {
    setReadyToRender(true);
  }, [
    fetchedConsumerGroups,
    consumerGroupsRequest,
    activityRequest,
    dataMapRequest,
    surveyRequest,
  ]);

  if (!readyToRender) {
    return (
      <GetCompliantPageWrapper>
        <Loading />
      </GetCompliantPageWrapper>
    );
  }

  return (
    <GetCompliantPageWrapper>
      <Header />

      <ol className="custom p-0">
        <li className="pb-md">Data Minimization</li>
        <li className="pb-md">Purpose Limitation</li>
      </ol>

      <SurveyGateButton
        slug="cpc-getting-started"
        survey={answers}
        updateResponse={setAnswer}
        label="Get Started"
      >
        <CorePrivacyConceptsSurvey
          answers={answers}
          setAnswer={setAnswer}
          activities={activities}
          collectedPic={collectedPic}
        />
      </SurveyGateButton>
    </GetCompliantPageWrapper>
  );
};
